import React, { useEffect, useState } from 'react';
import './WelcomeBackScreen.css';

const WelcomeBackScreen = () => {
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev > 1) return prev - 1;
        return prev;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="welcome-back-screen">
      <h1 className="welcome-title">🔥 Welcome Back, Listing Roaster! 🔥</h1>
      
      <p className="welcome-subtitle">
        Your Amazon optimization addiction is our favorite problem.
      </p>

      <p className="welcome-message">
        Loading your roasting tools... prepare for brutal honesty in {countdown}
        <span className="loading-dots"></span>
      </p>
    </div>
  );
};

export default WelcomeBackScreen;
